<template>
  <DateColumn :date="batchCreatedAt" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import DateColumn from '@/components/GraphqlDataTable/columns/DateColumn.vue'

const PaymentRequestBatchCreatedAtColumn = graphql(`
  fragment PaymentRequestBatchCreatedAtColumn on PaymentRequest {
    id
    batches {
      data {
        createdAt
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestBatchCreatedAtColumn>
}>()

const column = computed(() => useFragment(PaymentRequestBatchCreatedAtColumn, props.row))
const batchCreatedAt = computed(() => column.value.batches?.data[0]?.createdAt)
</script>
